// businesslocations/LocationRow.js
import LocationActionsDropdown from "./LocationActionsDropdown";

const LocationRow = ({ location, refresh }) => {
  const address = `${location.street}, ${location.city}, ${location.state} ${location.zip}`;

  return (
    <tr className="border-t">
      <td className="p-4 font-medium">{location.name}</td>

      <td>
        <span
          className={`px-3 py-1 text-xs rounded-full ${
            location.isActive
              ? "bg-green-100 text-green-700"
              : "bg-gray-200 text-gray-600"
          }`}
        >
          {location.isActive ? "Active" : "Inactive"}
        </span>
      </td>

      <td>{address}</td>
      <td className="p-4">
          {location.waiverCount ?? "—"}
      </td>

      <td className="p-4">
          {location.signedCount ?? "—"}
      </td>

      <td className="p-4">
          {location.qrCodeCount ?? "—"}
      </td>

      <td className="text-right pr-4">
        <LocationActionsDropdown location={location} refresh={refresh} />
      </td>
    </tr>
  );
};

export default LocationRow;